import { render, staticRenderFns } from "./ManualTable.vue?vue&type=template&id=13919c64&scoped=true&"
import script from "./ManualTable.vue?vue&type=script&lang=js&"
export * from "./ManualTable.vue?vue&type=script&lang=js&"
import style0 from "./ManualTable.vue?vue&type=style&index=0&id=13919c64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13919c64",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
